








import { Component, Prop, Vue } from 'vue-property-decorator'
@Component({
  name:'NoData'
})
export default class NoData  extends Vue {
  @Prop({default:'暂无数据'}) title!:string
  @Prop({default:false}) simpleImage?:any
}
